export const createAddUniqueNumber = (generateUniqueNumber) => {
    return (set) => {
        const number = generateUniqueNumber(set);
        set.add(number);
        return number;
    };
};
//# sourceMappingURL=add-unique-number.js.map